import React, { useState } from "react";
import aboutFaqsBrushImg from "../../secondAssets/Images/aboutFaqsBrushImg.png";
import aboutFaqImg from "../../secondAssets/Images/aboutFaqImg.jpeg"
import { aboutDentalCareData, aboutFaqs, aboutPricingCardData, aboutSolutionData } from "../../secondUtils/constants";
import { FaRegCircle } from "react-icons/fa";
import aboutHeaderImg from "../../secondAssets/Images/aboutHeaderImg.png";
import { ServiceHeader } from "../../SecondComponents";

const About = (props) => {
    const [activeIndex, setActiveIndex] = useState(0)
    const { selectedLanguage, language } = props
    const isELSelect = language?.language === 'english'
    const isAlSelect = language?.language === 'arabic'
    const toggleActiveIndex = (index) => {
        setActiveIndex(index);
    };
    return (
        <div className="main">
            <div className="second-design-service-container">
                <div className="service-top-div">
                    <div>
                        <h1>{selectedLanguage?.txt_about}</h1>
                    </div>
                </div>
                <div className="about-faqs-container">
                    <div className="aboutFaqs-heading-div">
                        <img src={aboutFaqsBrushImg} alt="" />
                        <div>
                            <h1>{selectedLanguage?.txt_why_we_are_the_best}</h1>
                            <p>{selectedLanguage?.txt_the_journey_of_thousand}</p>
                        </div>
                        <div className="aboutFaqs-main">
                            <div className="aboutFaqs-question-div">
                                {aboutFaqs.map((v, i) => (
                                    <div key={i}>
                                        <div className="about-faqs-question-div" onClick={() => toggleActiveIndex(i)}>
                                            <button><FaRegCircle /></button>
                                            <h2 className={activeIndex === i ? "about-faqs-question active-question" : "about-faqs-question"}>
                                                {isELSelect ? v?.question : (isAlSelect ? v?.alQuestion : v?.glQuestion)}
                                            </h2>
                                        </div>
                                        {activeIndex === i ? <p className="about-answer">
                                            {isELSelect ? v?.answer : (isAlSelect ? v?.alAnswer : v?.glAnswer)}
                                        </p> : null}
                                    </div>
                                ))}
                            </div>
                            <div className="aboutFaq-img-div"
                                data-aos="fade-down"
                                data-aos-easing="ease-out-bounce"
                                data-aos-delay="300"
                                data-aos-duration="2000">
                                <img src={aboutFaqImg} alt="" />
                            </div>
                        </div>
                    </div>
                </div>
                <div className="aboutHeader-main">
                    <ServiceHeader className='about-dental-header' serviceHeaderImg={aboutHeaderImg} serviceHeading={selectedLanguage?.txt_our_dental_pricing} serviceText={selectedLanguage?.txt_two_pains_are_to_be_endured} />
                </div>
                <div className="about-pricing-card-main">
                    {
                        aboutPricingCardData?.map((v, i) => {
                            return (
                                <div
                                    data-aos="fade-up"
                                    data-aos-easing="ease-out-bounce"
                                    data-aos-delay="300"
                                    data-aos-duration="2000">
                                    <div className={i === 1 ? "pricing-card-header center-pricing-card" : "pricing-card-header"}>
                                        <div className="pricing-card-heading">
                                            <h2>
                                                {isELSelect ? v?.name : (isAlSelect ? v?.alName : v?.glName)}
                                            </h2>
                                            <p>
                                                {isELSelect ? v?.text : (isAlSelect ? v?.alText : v?.glText)}
                                            </p>
                                        </div>
                                        <div className="price-div">
                                            <h6> <sup>$</sup>99<sup>.99</sup><span> / {selectedLanguage?.txt_month} </span></h6>
                                        </div>
                                    </div>
                                    <div className="pricing-list-main">
                                        <ul>
                                            {
                                                isELSelect ? v?.features?.map((feature, index) => (
                                                    <li key={index}>{feature}</li>
                                                ))
                                                    :
                                                    (
                                                        isAlSelect ? v?.alFeatures?.map((feature, index) => (
                                                            <li key={index}>{feature}</li>
                                                        ))
                                                            :
                                                            v?.glFeatures?.map((feature, index) => (
                                                                <li key={index}>{feature}</li>
                                                            ))
                                                    )
                                            }
                                        </ul>
                                    </div>
                                    <div className={i === 1 ? "pricing-card-header center-pricing-card" : "pricing-card-header"}>
                                        <button className="priciing-btn">{selectedLanguage?.txt_signup_now}</button>
                                    </div>
                                </div>
                            )
                        })
                    }
                </div>
                <div className="aboutSolution-bg-section">
                    <div className="aboutSolution-bg-section-overlap-div">
                        <div className="aboutSolution-main">
                            <div className="aboutSolution-top-div">
                                {
                                    aboutSolutionData?.map((v, i) => {
                                        return (
                                            <div
                                                data-aos="flip-left"
                                                data-aos-easing="ease-out-cubic"
                                                data-aos-duration="2000">
                                                <img src={v?.img} alt="" />
                                                <h2>
                                                    {isELSelect ? v?.heading : (isAlSelect ? v?.alHeading : v?.glHeading)}
                                                </h2>
                                                <span>
                                                    {v?.description}
                                                    {isELSelect ? v?.description : (isAlSelect ? v?.alDescription : v?.glDescription)}
                                                </span>
                                                <p>
                                                    {isELSelect ? v?.text : (isAlSelect ? v?.alText : v?.glText)}
                                                </p>
                                            </div>
                                        )
                                    })
                                }
                            </div>
                            <div className="aboutSolution-bottom-div"
                                data-aos="fade-down"
                                data-aos-easing="ease-out-bounce"
                                data-aos-delay="300"
                                data-aos-duration="2000">
                                <h2>
                                    {selectedLanguage?.txt_you_are_always_safe_with_us} <span> {selectedLanguage?.txt_we_are_ready_to_help_any_time}</span>
                                </h2>
                                <p>{selectedLanguage?.txt_if_you_are_going_to_passage}</p>
                                <button>{selectedLanguage?.txt_fix_an_appointment_with_us}</button>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="about-dentalCare-main">
                    <div className="about-dentalCare-left-div" data-aos="fade-right"
                        data-aos-easing="ease-out-bounce"
                        data-aos-delay="300"
                        data-aos-duration="2000">
                        <h2>{selectedLanguage?.txt_welcome_to} <span>{selectedLanguage?.txt_dental_care}</span></h2>
                        <p>{selectedLanguage?.txt_two_pains_are_to_be_borne_by_those_who_choose}</p>
                        <p>{selectedLanguage?.txt_and_of_these_things}</p>
                        <button className="about-dentalCare-left-div-btn-1">{selectedLanguage?.txt_know_your_facts}</button>
                        <button className="about-dentalCare-left-div-btn-2">{selectedLanguage?.txt_talk_to_us}</button>
                    </div>
                    <div className="about-dentalCare-right-div">
                        {
                            aboutDentalCareData?.map((v, i) => {
                                return (
                                    <div data-aos="flip-left"
                                        data-aos-easing="ease-out-cubic"
                                        data-aos-duration="2000">
                                        <div>
                                            <button>
                                                {v?.icon}
                                            </button>
                                        </div>
                                        <div className="about-dentalCare-right-card-text">
                                            <h2>
                                                {isELSelect ? v?.heading : (isAlSelect ? v?.alHeading : v?.glHeading)}
                                            </h2>
                                            <p>
                                                {isELSelect ? v?.text : (isAlSelect ? v?.alText : v?.glText)}
                                            </p>
                                        </div>
                                    </div>
                                )
                            })
                        }
                    </div>
                </div>
            </div>
        </div>
    )
}

export default About 